module.exports = __webpack_public_path__ + "static/media/expand_more_black_24dp.90a47117.svg";